import { render, staticRenderFns } from "./GridLastLevel.vue?vue&type=template&id=15c2155f"
import script from "./GridLastLevel.vue?vue&type=script&lang=js"
export * from "./GridLastLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports